import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { z } from "zod";

dayjs.extend(customParseFormat);

const DATE_FORMAT = "DD.MM.YYYY";

const isValidBirthDate = (value: string): boolean => {
    const parsed = dayjs(value, DATE_FORMAT, true);

    if (!parsed.isValid()) {
        return false;
    }

    return parsed.isBefore(dayjs().add(1, "day"), "day");
};

export const ContractWithdrawalInputSchema = z.object({
    contractOrProposalId: z
        .string()
        .min(1, "Číslo návrhu alebo poistnej zmluvy je povinné"),

    email: z
        .string()
        .min(1, "Emailová adresa je povinná")
        .email("Zadajte platnú emailovú adresu"),

    birthDate: z
        .string()
        .min(1, "Dátum narodenia poistníka je povinný")
        .refine(
            isValidBirthDate,
            "Zadajte platný dátum vo formáte DD.MM.YYYY"
        ),
});

export type ContractWithdrawalInput = z.infer<
    typeof ContractWithdrawalInputSchema
>;